// extracted by mini-css-extract-plugin
module.exports = {"container":"Chart_Village_Species_Board_container__kcjGY","wrapper-chart":"Chart_Village_Species_Board_wrapper-chart__BDrB1"};